/* Константа содержащая пункты мменю
 * выбора проекта Звезды и ссылки на них */

export const menu = [
  {
    name: 'МЕДИАГРУППА «ЗВЕЗДА»',
    link: 'https://tvzvezda.ru/mediaholding/',
  },
  {
    name: 'Телеканал Звезда',
    link: 'https://tvzvezda.ru/',
  },
  {
    name: 'Звезда плюс',
    link: 'https://tvzvezda.ru/sp/zvezda-plus/',
  },
  {
    name: 'Смарт ТВ',
    link: 'https://tvzvezda.ru/sp/smart/',
  },
  {
    name: 'Мобильное приложение',
    link: 'https://tvzvezda.ru/sp/android/\n',
  },

  {
    name: 'Главкино',
    link: 'https://glavkino.ru/',
  },
  {
    name: 'Звезда Live',
    link: 'https://zvezdalive.ru/',
  },
];
